import { fetcher } from '../utils'
import { ComponentInfoChatVO, ComponentTagVO } from '@repo/types'

export default async (
  input: ComponentTagVO,
  connectionKey: string,
  phoneNumber: string
): Promise<ComponentInfoChatVO> => fetcher(`/api/tag/${connectionKey}/${phoneNumber}/add`, 'POST', input)
